module.exports = __webpack_public_path__ + "static/media/Collect.710a8790.wav";